import { Button, ButtonProps, GlobalToken } from 'antd';
import { createStyles } from 'antd-style';
import React, { ReactElement } from 'react';

type StyleType = 'primary' | 'secondary' | 'tertiary' | 'agenda' | undefined;

type StyleButtonProps = ButtonProps & {
  styleType?: StyleType;
};

const useTaskStyles = createStyles((_props: { isDarkMode?: boolean; token: GlobalToken }) => {
  const { token } = _props;
  return {
    global: {
      height: '32px'
    },
    secondary: {
      color: '#FFF'
    },
    tertiary: {
      border: `1px solid transparent`,
      ':hover': {
        color: token.colorText,
        background: token.colorBgContainer,
        border: `1px solid ${token.Button?.defaultHoverBorderColor}`,
        boxShadow: 'none'
      }
    },
    primary: {
      background: `#113B8E80`,
      border: '1px solid transparent',
      ':hover': {
        border: `1px solid #fff`,
        boxShadow: 'none'
      }
    },
    agenda: {
      // start generated with anima
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '8px',
      // end generated with anima
      background: `#113B8E80`,
      border: '1px solid transparent',
      ':hover': {
        border: `1px solid #fff`,
        boxShadow: 'none'
      },
      width: 224
    }
  };
});

export default function StyleButton({
  styleType,
  className,
  ...rest
}: StyleButtonProps): ReactElement {
  const { cx, styles } = useTaskStyles();

  return <Button className={cx(styles[`${styleType}`], className, styles.global)} {...rest} />;
}
